module.exports = __webpack_public_path__ + "img/desktop.80b0276c.png";